module.exports = __webpack_public_path__ + "img/group@0.5x.d598fd52.jpg";